/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetTrialStatusQueryResponse, GetTrialStatusPathParams, GetTrialStatus400, GetTrialStatus401, GetTrialStatus403, GetTrialStatus404, GetTrialStatus409, GetTrialStatus500 } from "../../types/platformBillingController/GetTrialStatus.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetTrialStatusUrl(organizationId: GetTrialStatusPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/trial-status` as const }
  return res
}

/**
 * @summary Get trial status
 * {@link /api/organizations/:organizationId/platform-billing/trial-status}
 */
export async function getTrialStatus(organizationId: GetTrialStatusPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetTrialStatusQueryResponse, ResponseErrorConfig<GetTrialStatus400 | GetTrialStatus401 | GetTrialStatus403 | GetTrialStatus404 | GetTrialStatus409 | GetTrialStatus500>, unknown>({ method : "GET", url : getGetTrialStatusUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}